export default __webpack_public_path__ + "static/media/trueIcon.ad60a413.svg";